module.exports = __webpack_public_path__ + "img/61.3b11b4ce.jpg";